import { LoaderCircle } from "lucide-react";
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get(
      "session_id",
    );
    const returnTo = location.pathname.startsWith("/pilot/claim")
      ? `${location.pathname}${location.search}`
      : "/";
    const completeSignIn = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/auth/google-session`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ session_id: sessionId }),
          },
        );
        if (!response.ok) throw new Error("Google sign-in failed");
        window.history.replaceState(null, "", window.location.pathname);
        navigate(returnTo, { replace: true });
      } catch (error) {
        toast.error("Google sign-in could not be completed.");
        navigate("/login", { replace: true });
      }
    };
    completeSignIn();
  }, [location.hash, location.pathname, location.search, navigate]);

  return (
    <main className="auth-loading" data-testid="google-auth-callback">
      <LoaderCircle className="payment-spinner" size={30} />
    </main>
  );
}
